import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { PropsWithChildren, useState } from 'react';

import { useGetQueryClient } from '@/config/useGetQueryClient.util.ts';

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(d => ({
    default: d.ReactQueryDevtools,
  })),
);
export const QueryClientWrapper: React.FC<PropsWithChildren> = props => {
  const queryClient = useGetQueryClient();
  const [devToolsVisible] = useState(window.location.search.includes('DEV_TOOLS'));

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {props.children}
      {devToolsVisible && (
        <React.Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </React.Suspense>
      )}
    </QueryClientProvider>
  );
};
